import { useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';

import { useGetCurrentCompany } from 'src/hooks/companies/get-current-company.hook';

export const GET_ABSENCE_REASONS_BY_COMPANY = gql`
  query ($companyId: String!) {
    getAbsenceReasonsByCompany(companyId: $companyId) {
      _id
      name
      color
    }
  }
`;

export const ABSENCE_REASONS_CHANGED_SUBSCRIPTION = gql`
  subscription absenceReasonsChanged($companyId: String!) {
    absenceReasonsChanged(companyId: $companyId) {
      trigger
      absenceReason {
        _id
        name
        color
      }
    }
  }
`;

export const useGetAbsenceReasonsByCompany = (companyId: String = '') => {
  const { data, loading } = useQuery(GET_ABSENCE_REASONS_BY_COMPANY, { variables: { companyId } });
  const absenceReasons = data?.getAbsenceReasonsByCompany || [];

  return { loading, absenceReasons };
};

export const useGetAbsenceReasonForGantt = () => {
  const {
    company: { _id: companyId },
  } = useGetCurrentCompany();
  const { data, loading, subscribeToMore } = useQuery(GET_ABSENCE_REASONS_BY_COMPANY, {
    variables: { companyId },
    skip: !companyId,
  });
  const absenceReasons = data?.getAbsenceReasonsByCompany || [];

  useEffect(() => {
    subscribeToMore({
      document: ABSENCE_REASONS_CHANGED_SUBSCRIPTION,
      variables: { companyId },
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;

        const { trigger, absenceReason } = subscriptionData.data?.absenceReasonsChanged || {};
        const reasons = prev?.getAbsenceReasonsByCompany || [];
        const newReasons = [...reasons];
        const findIndex = reasons.findIndex((value: any) => value._id === absenceReason._id);

        if (trigger === 'absenceReasonCreated' && findIndex < 0) {
          newReasons.push(absenceReason);
        }

        if (findIndex > -1) {
          if (trigger === 'absenceReasonRemoved') {
            newReasons.splice(findIndex, 1);
          }

          if (trigger === 'absenceReasonUpdated') {
            newReasons[findIndex] = absenceReason;
          }
        }

        return { getAbsenceReasonsByCompany: newReasons };
      },
    });
  }, [subscribeToMore, companyId]);

  return { loading, absenceReasons };
};
